<template>
	<div class="system-mini-program">
		<table-pagination
		  v-loading="loading"
		  ref="tableItem"
		  pagination
		  layout="prev,pager,next,total"
		  :data="data"
		  :column="column"
		  :total="total"
		  :page.sync="listQuery.pageNum"
		  :limit.sync="listQuery.pageSize"
		  @pagination="getList"
		/>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loading:false,
				data:[],
				status:[{name:'失败',key:0},{name:'成功',key:1},{name:'加载中',key:2}],
				column:[
					{ label: "序号", prop: "index", type: "index" },
					{ label: "品牌", prop: "brand" },
					{ label: "时间", prop: "lastUpdateTime",width:150,},
					{ label: "APP描述", prop: "appDesc",width: 300 ,align: "center",},
					{
						label: "状态",
						prop: "status",
						render: (h, scope) => {
							return  <span style={`${this.setTextColor(scope.row.status)}`}><i class='iconfont major-dian'></i>{scope.row.status}</span>
						}
					},
					{ label: "成功数量", prop: "successNum",render:(h,scope) => {return <span>{scope.row.successNum || 0}</span>} },
					{ 
						label: "失败原因",
						 prop: "reson" ,
						 width: 200 ,
						 align: "center",
						 render:(h,scope) => {
							 return <span style={`${this.setTextColor(scope.row.status)}`}>{scope.row.failDesc}</span>
						 }
					},
					{
					  label: "操作",
					  prop: "cation",
					  align: "center",
					  width: 60,
					  fixed:'right',
					  render: (h, scope) => {
					    return (
					      <div class="operate-inline">
					        <el-button type="text" size="small" onClick={() => this.onOperate(scope.row)} style={`${this.setTextColor(scope.row.status)}`}>
								刷新
					        </el-button>
					      </div>
					    );
					  }
					}
				],
				total:0,
				listQuery:{
					pageNum:1,
					pageSize:10
				}
			}
		},
		methods:{
			getList(val){
				if(val){
					this.listQuery.pageNum = val.pageNum;
				}
				this.loading = true
				this.$api.getMiniData(this.listQuery).then(res => {
					if(res.errcode == 0) {
						this.loading = false
						this.data = res.list;
						this.total = res.total
					}
				})
			},
			onOperate(row){
				this.$api.refreshMiniData(row.brand,row.appId).then(res => {
					if(res.errcode == 0) {
						this.$message.success('已刷新成功，请稍后刷新页面查看数据')
					}
				})
			},
			setTextColor(status){
				if(status != '成功') {
					return 'color:#FF0000'
				}
				return "color:#47B267"
			}
		},
		mounted(){
			this.getList()
		}
	}
</script>

<style>
</style>
